import { c as _c } from "react/compiler-runtime";
import { BulkExportProjects } from "@components/table/projects/bulk-actions/bulk-export-projects";
import { MAP_EXPORT_EXCLUDED_COLUMNS } from "@utils/file-data-export";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { resetTableState, setTableType } from "@store/table/table-slice";
import { TableType } from "@utils/track-event/track-event-list";
import { useEffect, useMemo } from "react";
/**
 * Custom hook to handle the bulk actions for the projects map list.
 * @returns The available bulk actions and the currently selected projects.
 */
export function useProjectsMapBulkActions(t0) {
  const $ = _c(18);
  const {
    companyId,
    projects,
    projectArchivingState
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("mapProjects");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedProjects = useAppSelector(t1);
  const isAnyRowSelected = selectedProjects.length !== 0;
  let t2;
  if ($[1] !== isAnyRowSelected) {
    t2 = {
      export: isAnyRowSelected,
      changeProjectManagement: false,
      changeProjectStatus: false,
      removeProject: false,
      changeAccessLevel: false
    };
    $[1] = isAnyRowSelected;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isActionAllowedMap = t2;
  let t3;
  let t4;
  if ($[3] !== dispatch) {
    t3 = () => {
      dispatch(setTableType(TableType.mapProjects));
      return () => {
        dispatch(resetTableState());
      };
    };
    t4 = [dispatch];
    $[3] = dispatch;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== companyId || $[7] !== isActionAllowedMap.export || $[8] !== isAnyRowSelected || $[9] !== projectArchivingState || $[10] !== projects || $[11] !== selectedProjects) {
    t5 = isActionAllowedMap.export ? <BulkExportProjects companyId={companyId} selectedProjects={isAnyRowSelected ? selectedProjects : projects} subjectType="workspace" projectStatus={projectArchivingState} areEntitiesSelected={isAnyRowSelected} columnsToExclude={MAP_EXPORT_EXCLUDED_COLUMNS} viewMode="map" /> : null;
    $[6] = companyId;
    $[7] = isActionAllowedMap.export;
    $[8] = isAnyRowSelected;
    $[9] = projectArchivingState;
    $[10] = projects;
    $[11] = selectedProjects;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = {
      export: t5,
      changeProjectManagement: null,
      changeProjectStatus: null,
      removeProject: null,
      changeAccessLevel: null
    };
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const bulkActions = t6;
  let t7;
  if ($[15] !== bulkActions || $[16] !== selectedProjects) {
    t7 = {
      bulkActions,
      selectedProjects
    };
    $[15] = bulkActions;
    $[16] = selectedProjects;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}